import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=ec9cc90e&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"
import style0 from "./manage.vue?vue&type=style&index=0&id=ec9cc90e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9cc90e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec9cc90e')) {
      api.createRecord('ec9cc90e', component.options)
    } else {
      api.reload('ec9cc90e', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=ec9cc90e&scoped=true", function () {
      api.rerender('ec9cc90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/hwk/manage.vue"
export default component.exports